import React, { useState } from "react";
import { Route, Switch, useParams } from "react-router-dom";

import { Footer } from "AppSrc/footer";
import { ErrorBoundary } from "storybook-dashboard/errors";

import AccountTree from "AppSrc/tree";
import { CompanyRouter } from "AppSrc/company/router";
import { ProjectRouter } from "AppSrc/project/router";

import StyleSetter from "./styles";

import BootstrapSplitPane from "traec-react/utils/bootstrap/splitbs";

export default function CompanyProjectPage(props) {
  let { _companyId, _projectId, _refId } = useParams();
  const _id = _refId || _projectId || _companyId;

  const [showSideBar, setShowSideBar] = useState(true);
  const [draggedSize, setDraggedSize] = useState(300);

  return (
    <>
      <StyleSetter />
      <BootstrapSplitPane
        localStorageKey={`explorer-grid-split-${_id}`}
        allowZero={true}
        pane1ClassName={"page-sidebar"}
        onCollapseHook={() => setShowSideBar(false)}
        onExpandHook={() => setShowSideBar(true)}
        onDragFinished={(draggedSize) => setDraggedSize(draggedSize)}
        pane1Style={{
          borderRight: "1px solid grey",
          overflowY: "auto",
        }}
        pane2Style={{
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
        }}
      >
        <div>
          <main aria-label="Sidebar panel content">
            <ErrorBoundary>
              <Switch>
                <Route
                  path={["/project/:_projectId/wpack/:_refId", "/project/:_projectId", "/company/:_companyId"]}
                  component={AccountTree}
                />
              </Switch>
            </ErrorBoundary>
          </main>
        </div>
        <div>
          <main aria-label="Main panel content">
            <ErrorBoundary>
              <Switch>
                {/* Route to a Company Dashboard */}
                <Route path="/company/:_companyId" component={CompanyRouter} />

                {/* Route to a Project or WorkPackage Dashboard */}
                <Route path="/project/:_projectId/wpack/:_refId" component={ProjectRouter} />
                <Route path="/project/:_projectId" component={ProjectRouter} />
              </Switch>
            </ErrorBoundary>
          </main>
        </div>
      </BootstrapSplitPane>
      <Footer />
    </>
  );
}
